import { createContext } from 'react';
import type { Season } from '../api/seasonsService';

export interface SeasonContextType {
  selectedSeason: Season | null;
  setSelectedSeason: (season: Season) => void;
  selectedYear: number | null;
}

export const SeasonContext = createContext<SeasonContextType | undefined>(undefined);

